export const OPEN_DETAILS_ON_PRESS_IMAGE = true;
